import styled from "styled-components";

export const StyledGoBackButton = styled.div`
  color: #000;
  display: inline-block;
  margin: 3px 5px;
  svg {
    cursor: pointer;
  }
`;
